import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlipCameraAndroidIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flip_camera_android"}/>
}
